/**
 * Warstwa API: TRYB TESTOWY POWIADOMIEŃ per spółka (polecenie właściciela 2026-10-02).
 *
 * Właściciel: przełącznik „Tryb testowy powiadomień” tak/nie przy głównej skrzynce KAŻDEJ firmy w /admin/integrations.
 * Włączony: aplikacja odbiera pocztę normalnie, każdy wychodzący e-mail idzie na skrzynkę powiadomień TEJ firmy,
 * SMS-y są wstrzymane, powiadomienia w aplikacji zostają.
 *
 * Trasy backendu (TrybTestowyPowiadomienController, `api/tryb-testowy-powiadomien`):
 *  - `GET moj` — każdy zalogowany: `{ aktywny, spolkaId, spolkaNazwa, od }` (baner nad nagłówkiem; w podglądzie konta
 *    odpowiada za konto oglądane);
 *  - `GET` — osoba z dostępem do integracji: `{ jakikolwiekWlaczony, failClosed, nieobjete[], wstrzymaneBezOdczytu,
 *    spolki[{ companyId, nazwa, wlaczony, od, ktoNazwa, cel{configurationId, displayName, emailAddress}|null,
 *    liczbaSkrzynekPowiadomien, licznik24h{przekierowane, zablokowaneMaile, zablokowaneSms, bezKontekstu}, ostrzezenia[] }] }`;
 *  - `PUT {companyId}` `{ wlaczony }` — zapis; odpowiedź to wiersz spółki z dopiskiem `{ uwaga, stanOdczytany }`.
 *    409 = spółka nie ma dokładnie jednej skrzynki powiadomień, 403 = brak dostępu do integracji.
 *
 * PIN ADMINISTRATORA: zapis stoi za RequireAdminPinFilter. Nie ma tu osobnego nagłówka — odmowę 403 `admin_pin_required`
 * przechwytuje interceptor w apiService.js, otwiera okno PIN-u (PinNaZadanie) i ponawia żądanie JEDEN raz. To ta sama
 * droga, którą idą pozostałe zapisy chronione PIN-em.
 *
 * Nazwy metod są długie świadomie: trafiają do wspólnego `apiService` i muszą być unikalne w całej aplikacji
 * (patrz attachApiModules).
 */
export function attach(api) {
    return {
        /** Czy MOJA spółka jest w trybie testowym: `{ aktywny, spolkaId, spolkaNazwa, od }`. */
        pobierzMojTrybTestowy: () => api.get("/tryb-testowy-powiadomien/moj"),

        /** Stan wszystkich spółek (tylko osoba z dostępem do integracji; inni dostają 403). */
        pobierzListeTrybuTestowego: () => api.get("/tryb-testowy-powiadomien"),

        /** Włącza albo wyłącza tryb testowy jednej spółki. */
        ustawTrybTestowy: (companyId, wlaczony) =>
            api.put(`/tryb-testowy-powiadomien/${companyId}`, { wlaczony: wlaczony === true }),
    };
}
